
define('text!templates/modules/conversation/message/send-message-modal.html',[],function () { return '<div class="alert-list"></div>\n<div class="message-chatbox"></div>\n';});

